var render, staticRenderFns
import script from "./TotalSumsMixin.vue?vue&type=script&lang=js&"
export * from "./TotalSumsMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70026d48",
  null
  
)

export default component.exports